import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateUserUrl } from "../../config";
import { Status } from "../../common/constants";
import api from '../../api';
import { IUserState, IEditUser } from "../../common/types/userTypes";
import { RootState } from "../../store";

const UPDATE_USER: string = "updateUser"

const initialState: IUserState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

interface IEditUserResponse {
  data: IEditUserResponse,

}

export const updateUser = createAsyncThunk(UPDATE_USER, async (payload: IEditUser, { rejectWithValue }) => {
  try {
    const response = await api.patch<IEditUserResponse>(updateUserUrl + `?userId=${payload.userId}`, payload.body);
    const updateUserResponse: IEditUserResponse = response.data;
    return updateUserResponse;
  } catch (error) {
    throw rejectWithValue(error);
  }
}
);

const updateUserModalSlice = createSlice({
  name: UPDATE_USER,
  initialState,
  reducers: {
    showModal: (state: IUserState) => {
      state.isActive = true;
    },
    hideModal: (state: IUserState) => {
      state.isActive = false;
    },
    setUserData: (state: IUserState, action) => {
      state.userData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUser.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.msg = "User Updated Successfully! ";
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(updateUser.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const actions = {
  updateUserModalSlice,
  ...updateUserModalSlice.actions,
};

export const selector = (state: RootState) => state.updateUser;

export default updateUserModalSlice.reducer;